export default __webpack_public_path__ + "images/61fa7a0d5be7c1997ae3f3dbba0190e1-seasonal_module_spd_parties_desktop.webp";